/**
 * Time-axis arithmetic for the EPG guide grid.
 *
 * Pure and parameterised on "now" so it can be tested — the guide is the one
 * screen where being a few pixels out is immediately visible, because the
 * now-line sits against programme blocks whose widths come from the same
 * scale. A mismatch between the two reads as "the guide is wrong" rather than
 * as a rounding error.
 */

export interface Tick { label: string; left: number }

/** Round down to the half hour so the ruler lands on readable marks. */
export function windowStartFor(nowS: number): number {
  return nowS - (nowS % 1800);
}

/** Horizontal offset of a moment, in pixels from the window origin. */
export function offsetPx(atS: number, windowStartS: number, minPx: number): number {
  return ((atS - windowStartS) / 60) * minPx;
}

/** Width of a programme block, clipped to the window so a show that started
 *  before the window opened does not hang off the left edge. */
export function blockWidthPx(
  startS: number,
  stopS: number,
  windowStartS: number,
  minPx: number,
  minMinutes = 4,
): number {
  const clipped = Math.max(startS, windowStartS);
  const minutes = Math.max(minMinutes, (stopS - clipped) / 60);
  return minutes * minPx;
}

export function ticksFor(
  windowStartS: number,
  hours: number,
  minPx: number,
  fmt: (epochS: number) => string,
): Tick[] {
  const out: Tick[] = [];
  for (let m = 0; m <= hours * 60; m += 30) {
    out.push({ label: fmt(windowStartS + m * 60), left: m * minPx });
  }
  return out;
}
